export default {
    data: () => ({
        timerData: {
            ids: [],
            status: []
        }
    }),
    methods: {
        timer(interval, callback) {
            const index = this.timerData.ids.length;
            const id = setInterval(function() {
                if (this.timerData.status[index])
                    return;

                this.timerData.status[index] = true;

                const self = this;
                let result = null;
                
                try {
                    result = callback();
                }
                catch {
                    self.timerData.status[index] = false;
                    return;
                }

                if (result && result.then) {
                    result.then(function() {
                        self.timerData.status[index] = false;
                    }).catch(function() {
                        self.timerData.status[index] = false;
                    });
                }
            }.bind(this), interval);

            this.timerData.ids.push(id);
            this.timerData.status.push(false);
        }
    },
    beforeDestroy() {
        this.timerData.ids.forEach(clearInterval);
    }
}